module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_symbol-673c6840636ae35021a2fe170eae9906.svg";